export default Object.freeze({
  Nuevo: 1,
  Procesado: 2,
  Pagado: 3,
  ArchivoGenerado: 4,
  EnviadoAFinanzas: 5,
});
